import { useEffect, useState } from 'react';
import { passwordSchema } from '@colette/shared';
import './vitrine.css';
import { C, DEGRADE_ACTION, POLICE_TITRE } from '../theme';
import { styleChamp } from '../app/composants/champs';
import { api } from '../api/routes';
import { messageDErreur } from '../api/useDonnees';
import { naviguer } from '../routeur';

/**
 * La page ouverte depuis le lien de l'email (2026-08-28).
 *
 * Le jeton arrive dans l'URL — c'est le mecanisme habituel, et le seul possible depuis
 * un email. On le RETIRE de la barre d'adresse des qu'il est lu : sans cela il resterait
 * dans l'historique du navigateur, et partirait dans l'en-tete `Referer` de toute page
 * ouverte ensuite. Sa duree d'une heure et son usage unique font le reste.
 */
export function Reinitialiser() {
  const [jeton, setJeton] = useState<string | null>(null);
  const [motDePasse, setMotDePasse] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);
  const [fait, setFait] = useState(false);

  useEffect(() => {
    const lu = new URLSearchParams(window.location.search).get('jeton');
    setJeton(lu);
    if (lu !== null) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);

  const verifie = passwordSchema.safeParse(motDePasse);
  const faute = motDePasse !== '' && !verifie.success ? verifie.error.issues[0]!.message : null;
  const peutEnvoyer = jeton !== null && verifie.success && !envoi;

  const enregistrer = async () => {
    if (!peutEnvoyer) return;
    setEnvoi(true);
    setErreur(null);
    try {
      await api.reinitialiser(jeton, motDePasse);
      setFait(true);
    } catch (cause) {
      setErreur(messageDErreur(cause));
    } finally {
      setEnvoi(false);
    }
  };

  return (
    <div className="v-page">
      <main className="v-section">
        <div
          className="v-contenu v-contenu--etroit"
          style={{ display: 'flex', flexDirection: 'column', gap: 'var(--e4)', maxWidth: 460 }}
        >
          <h1
            style={{
              fontFamily: POLICE_TITRE,
              fontWeight: 200,
              fontSize: 40,
              lineHeight: 1.1,
              margin: 0,
              color: C.encre,
            }}
          >
            Nouveau mot de passe
          </h1>

          {fait ? (
            <>
              <p className="v-texte">
                C’est fait. Tes autres appareils ont été déconnectés — reconnecte-toi avec
                ton nouveau mot de passe.
              </p>
              <button
                type="button"
                className="v-bouton v-bouton--principal"
                onClick={() => naviguer('/app')}
              >
                Ouvrir Colette
              </button>
            </>
          ) : jeton === null ? (
            <>
              <p className="v-texte">
                Ce lien est incomplet. Ouvre-le depuis l’email que Colette t’a envoyé, ou
                demandes-en un nouveau depuis l’écran de connexion.
              </p>
              <button
                type="button"
                className="v-bouton v-bouton--secondaire"
                onClick={() => naviguer('/app')}
              >
                Aller à la connexion
              </button>
            </>
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                void enregistrer();
              }}
              style={{ display: 'flex', flexDirection: 'column', gap: 'var(--e3)' }}
            >
              <p className="v-texte" style={{ margin: 0 }}>
                Choisis ton nouveau mot de passe. Tes autres appareils seront déconnectés.
              </p>
              <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <span
                  style={{ fontSize: 11.5, fontWeight: 800, letterSpacing: 0.6, color: C.tertiaire }}
                >
                  NOUVEAU MOT DE PASSE
                </span>
                <input
                  type="password"
                  value={motDePasse}
                  onChange={(e) => setMotDePasse(e.target.value)}
                  aria-label="Nouveau mot de passe"
                  autoComplete="new-password"
                  autoFocus
                  style={styleChamp}
                />
              </label>
              {faute !== null ? (
                <div style={{ fontSize: 12.5, fontWeight: 700, color: C.corailTexte }}>{faute}</div>
              ) : null}
              {erreur !== null ? (
                <div
                  role="alert"
                  style={{
                    background: C.corailFond,
                    border: `1px solid ${C.corailBordure}`,
                    color: C.corailTexte,
                    borderRadius: 12,
                    padding: '12px 14px',
                    fontSize: 13.5,
                    fontWeight: 700,
                  }}
                >
                  {erreur}
                </div>
              ) : null}
              <button
                type="submit"
                disabled={!peutEnvoyer}
                style={{
                  height: 52,
                  border: 'none',
                  borderRadius: 14,
                  background: peutEnvoyer ? DEGRADE_ACTION : C.inactif,
                  color: '#FFFFFF',
                  fontSize: 16,
                  fontWeight: 800,
                  fontFamily: 'inherit',
                  cursor: peutEnvoyer ? 'pointer' : 'default',
                }}
              >
                {envoi ? '…' : 'Enregistrer'}
              </button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
